import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_adiantamento';
import styles from "./styles.module.css";
import { BsFillPlusCircleFill, BsSearch } from "react-icons/bs";
import Swal from 'sweetalert2';

export default function Usuario() {

    const [usuarios, setUsuarios] = useState([]);
    const [selectedUsuario, setSelectedUsuario] = useState({});
    const [modalUsuarioOpen, setModalUsuarioOpen] = useState(false);
    const [usuario, setUsuario] = useState('');
    const [matricula, setMatricula] = useState('');
    const [nome, setNome] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [perfis, setPerfis] = useState([]);
    const [empAreas, setEmpAreas] = useState([]);
    const [dashboards, setDashboards] = useState([]);
    const [exportadores, setExportadores] = useState([]);
    const [pessoa, setPessoa] = useState({});
    const [atualizar, setAtualizar] = useState(true);
    const [setores, setSetores] = useState({
        items: [
            { id: 0, text: '' }
        ],
        selectItem: 0,
    });
    const [modalPessoaOpen, setModalPessoaOpen] = useState(false);
    const [empPessoas, setEmpPessoas] = useState({
        items: [
        ],
        selectItem: 0,
    })
    const [pessoas, setPessoas] = useState([]);

    useEffect(() => {
        if(!modalUsuarioOpen) {
            setEmpresas([]);
            setModulos([]);
            setPerfis([]);
            setEmpAreas([]);
            setDashboards([]);
            setExportadores([]);
            setSelectedUsuario({});
        }

    }, [modalUsuarioOpen]);

    useEffect(() => {
        if (atualizar) {
            api.get(`/usuarios`).then(function (response) {
                if (response.data) {
                    setUsuarios(response.data);

                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
                setAtualizar(false);
            });
        }

    }, [atualizar]);

    useEffect(() => {
        if(selectedUsuario.id) {
            if (selectedUsuario.pessoa && selectedUsuario.pessoa.id) {
                setPessoa(selectedUsuario.pessoa);
            }
            if (selectedUsuario.adi_setor_id) {
                handleSelectSetor(selectedUsuario.adi_setor_id);
            } else {
                handleSelectSetor(0);
            }
        } else {
            setPessoa({});
            handleSelectSetor(0);
        }

    }, [selectedUsuario]);

    useEffect(() => {

        api.get(`/adiantamento/getsetores`).then(function (response) {
            if (response.data) {

                var itens = [{ id: 0, text: '' }];
                response.data.forEach((setor, index) => {
                    var item = { id: setor.id, text: setor.descricao }
                    itens.push(item);
                })
                var perfs = {};
                perfs.items = itens;
                perfs.selectItem = 0;
                setSetores(perfs);

            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
            setAtualizar(false);
        });

    }, []);

    useEffect(() => {

        api.get(`/empresa`).then(function (response) {
            if (response.data) {

                var itens = [];
                response.data.forEach((empresa, index) => {
                    var item = { id: empresa.id, text: empresa.descempresa }
                    itens.push(item);
                })
                var emps = {};
                emps.items = itens;
                emps.selectItem = response.data[0].id;
                setEmpPessoas(emps);

            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    function renderRow() {
        return (
            usuarios.map((usuario, index) => {
                return (
                    <tr key={index} className={styles.clicktb} onClick={() => handleOpenModalUsuario(usuario)}>
                        <td>{usuario.usuario}</td>
                        <td>{(usuario.adi_setor && usuario.adi_setor.id ? usuario.adi_setor.descricao : '')}</td>
                        <td>{(usuario.pessoa && usuario.pessoa.nome ? usuario.pessoa.nome : '')}</td>
                    </tr>
                )
            })
        )
    }

    function handleCheckEmp(check, index) {
        var objEmp = Object.assign([], empresas);

        var idusuario = null;
        if (selectedUsuario && selectedUsuario.id) {
            idusuario = selectedUsuario.id
        } else {
            idusuario = 999999999999;
        }

        if (!check) {
            objEmp[index].usuarios_empresas = []
        } else {
            objEmp[index].usuarios_empresas = [{
                empresa_id: objEmp[index].id,
                usuario_id: idusuario,
            }]
        }

        setEmpresas(objEmp);
    }


    function renderEmpresas() {
        return (
            empresas.map((empresa, index) => {
                if (empresa.usuarios_empresas[0] && empresa.usuarios_empresas[0].usuario_id) {
                    return (
                        <div key={index} className={styles.divempresa}><input type="checkbox" checked onChange={() => handleCheckEmp(0, index)} />{empresa.descempresa}</div>
                    )
                } else {
                    return (
                        <div key={index} className={styles.divempresa}><input type="checkbox" onChange={() => handleCheckEmp(1, index)} />{empresa.descempresa}</div>
                    )
                }
            })
        )
    }

    function handleCheckPerfil(check, index) {

        var objPerfis = Object.assign([], perfis);
        var idusuario = null;

        if (selectedUsuario && selectedUsuario.id) {
            idusuario = selectedUsuario.id
        } else {
            idusuario = 999999999999;
        }

        if (!check) {
            objPerfis[index].usuarios_perfis = []
        } else {
            objPerfis[index].usuarios_perfis = [{
                perfil_id: objPerfis[index].id,
                usuario_id: idusuario,
            }]
        }
        setPerfis(objPerfis);
    }


    function renderPerfis() {
        return (
            perfis.map((perfil, index) => {
                if (perfil.usuarios_perfis[0] && perfil.usuarios_perfis[0].usuario_id) {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" checked onChange={() => handleCheckPerfil(0, index)} />{perfil.descricao}</div>
                    )
                } else {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" onChange={() => handleCheckPerfil(1, index)} />{perfil.descricao}</div>
                    )
                }
            })
        )
    }

    function handleCheckModulo(check, index) {
        var objModulo = Object.assign([], modulos);

        var idusuario = null;
        if (selectedUsuario && selectedUsuario.id) {
            idusuario = selectedUsuario.id
        } else {
            idusuario = 999999999999;
        }

        if (!check) {
            objModulo[index].usuarios_modulos = []
        } else {
            objModulo[index].usuarios_modulos = [{
                modulos_id: objModulo[index].id,
                usuario_id: idusuario,
            }]
        }

        setModulos(objModulo);
    }

    function rederModulos() {
        return (
            modulos.map((modulo, index) => {
                if (modulo.usuarios_modulos[0] && modulo.usuarios_modulos[0].usuario_id) {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" checked onChange={() => handleCheckModulo(0, index)} />{modulo.descricao}</div>
                    )
                } else {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" onChange={() => handleCheckModulo(1, index)} />{modulo.descricao}</div>
                    )
                }
            })
        )
    }

    function handleCheckArea(check, index, empresa_id) {
        var objEmp = Object.assign([], empAreas);

        var emp = objEmp.find(emp => emp.id === empresa_id);

        var idusuario = null;
        if (selectedUsuario && selectedUsuario.id) {
            idusuario = selectedUsuario.id
        } else {
            idusuario = 999999999999;
        }

        if (!check) {
            emp.orc_areas[index].orc_usuarios_areas = []
        } else {
            emp.orc_areas[index].orc_usuarios_areas = [{
                orc_areas_id: emp.orc_areas[index].id,
                usuario_id: idusuario,
                empresa_id: empresa_id,
            }]
        }

        setEmpAreas(objEmp);
    }

    function renderAreas(areas, empresa_id) {

        return (
            areas.map((area, index) => {

                const objEmp = Object.assign({}, empresas.find(emp => emp.id === empresa_id));

                if (objEmp.usuarios_empresas[0] && objEmp.usuarios_empresas[0].usuario_id) {

                    if (area.orc_usuarios_areas[0] && area.orc_usuarios_areas[0].usuario_id) {
                        return (
                            <div className={styles.divempresa}><input type="checkbox" checked onChange={() => handleCheckArea(0, index, empresa_id)} />{area.descricao}</div>
                        )
                    } else {
                        return (
                            <div className={styles.divempresa}><input type="checkbox" onChange={() => handleCheckArea(1, index, empresa_id)} />{area.descricao}</div>
                        )
                    }
                } else {
                    return (
                        <div className={styles.divempresa}>{area.descricao}</div>
                    )
                }
            })
        )

    }

    function renderEmpAreas() {
        return (
            empAreas.map((emp) => {
                return (
                    <div className={styles.divareas}>{emp.descempresa}
                        <hr />
                        {renderAreas(emp.orc_areas, emp.id)}
                    </div>
                )
            })
        )
    }


    function handleClickSalvar() {

        var empresasEnviar = [];
        empresas.forEach((empresa) => {
            if (empresa.usuarios_empresas[0] && empresa.usuarios_empresas[0].usuario_id) {
                empresasEnviar.push(empresa)
            }
        })

        var modulosEnviar = [];
        modulos.forEach((modulo) => {
            if (modulo.usuarios_modulos[0] && modulo.usuarios_modulos[0].usuario_id) {
                modulosEnviar.push(modulo)
            }
        })

        var perfisEnviar = [];
        perfis.forEach((perfil) => {
            if (perfil.usuarios_perfis[0] && perfil.usuarios_perfis[0].usuario_id) {
                perfisEnviar.push(perfil)
            }
        })

        const moduloOrcamento = modulosEnviar.find(modulo => modulo.descricao === 'ORÇAMENTO');
        var areasEnviar = [];
        if (moduloOrcamento) {
            if (empresasEnviar.length > 0) {
                empAreas.forEach((empArea) => {
                    empresasEnviar.forEach((emp) => {
                        if (emp.id === empArea.id) {
                            empArea.orc_areas.forEach((area) => {
                                if (area.orc_usuarios_areas[0] && area.orc_usuarios_areas[0].usuario_id) {
                                    areasEnviar.push(area);
                                }
                            })
                        }
                    })
                })
            }
        }

        var dashboardsEnviar = [];
        dashboards.forEach((dashboard) => {
            if (dashboard.user_relatorios[0] && dashboard.user_relatorios[0].usuario_id) {
                dashboardsEnviar.push(dashboard);
            }
        })

        var exportadoresEnviar = [];
        exportadores.forEach((exportador) => {
            if (exportador.usuarios_exportador[0] && exportador.usuarios_exportador[0].usuario_id) {
                exportadoresEnviar.push(exportador)
            }
        })

        if (!usuario || usuario === '') {
            Swal.fire('O USUÁRIO NÃO PODE FICAR EM BRANCO!');
            return;
        }

        if (empresasEnviar.length <= 0) {
            Swal.fire('PARA ACESSAR O SISTEMA É NECESSÁRIO PELO MENOS UMA EMPRESA LIBERADA!');
            return;
        }

        if (modulosEnviar.length <= 0) {
            Swal.fire('PARA ACESSAR O SISTEMA É NECESSÁRIO PELO MENOS UM MÓDULO LIBERADO!');
            return;
        }

        if (moduloOrcamento && areasEnviar.length <= 0) {
            Swal.fire('PARA LIBERAR O MÓDULO DE ORÇAMENTO, SERÁ NECESSÁRIO PELO MENOS UMA ÁREA ATRIBUIDA!');
            return;
        }

        const moduloDashboards = modulosEnviar.find(modulo => modulo.descricao === 'DASHBOARDS');
        if (moduloDashboards && dashboardsEnviar.length <= 0) {
            Swal.fire('PARA LIBERAR O MÓDULO DE DASHBOARDS, SERÁ NECESSÁRIO PELO MENOS UM DASHBOARD ATRIBUIDO!');
            return;
        }

        const moduloExportadores = modulosEnviar.find(modulo => modulo.descricao === 'EXPORTADORES');
        if (moduloExportadores && exportadoresEnviar.length <= 0) {
            Swal.fire('PARA LIBERAR O MÓDULO DE EXPORTADORES, SERÁ NECESSÁRIO PELO MENOS UM EXPORTADOR ATRIBUIDO!');
            return;
        }

        const body = {
            usuario: usuario,
            empresas: empresasEnviar,
            modulos: modulosEnviar,
            perfis: perfisEnviar,
            areas: areasEnviar,
            exportadores: exportadoresEnviar,
            dashboards: dashboardsEnviar,
            id_setor: parseInt(setores.selectItem),
            pessoa_id: pessoa.id,
        }

        if (selectedUsuario && selectedUsuario.id) {

            body.id = selectedUsuario.id;

            api.put(`/usuarios`, body).then(function (response) {
                if (response.data) {
                    // setUsuarios(response.data);
                    setAtualizar(true);
                    setModalUsuarioOpen(false);
                    Swal.fire('USUÁRIO ATUALIZADO COM SUCESSO!');
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        } else {

            api.post(`/usuarios`, body).then(function (response) {
                if (response.data) {
                    // setUsuarios(response.data);
                    setAtualizar(true);
                    setModalUsuarioOpen(false);
                    Swal.fire('USUÁRIO CADASTRADO COM SUCESSO!');
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }

    }

    function handleResetSenha() {
        const body = {
            id: selectedUsuario.id,
            novaSenha: '',
        }
        api.post(`/usuarios/change`, body).then(function (response) {
            if (response.data) {
                // setUsuarios(response.data);
                Swal.fire('SENHA REDEFINDA PARA A SENHA PADRÃO ("SEM SENHA")!');
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });


    }

    function renderAreasOrcamento() {
        const objModulo = Object.assign({}, modulos.find(modulo => modulo.id === 5));

        if (objModulo.usuarios_modulos && objModulo.usuarios_modulos[0] && objModulo.usuarios_modulos[0].usuario_id) {
            return (
                <>
                    <hr />
                    <div>
                        <div><b>ÁREAS ORÇAMENTO</b></div>
                        <div className={styles.divempareas}>
                            {renderEmpAreas()}
                        </div>
                    </div>
                </>
            )
        } else {
            return (<></>)
        }
    }

    function renderBtnRedefinir() {
        if (selectedUsuario && selectedUsuario.id) {
            return (
                <input type="button" value="REDEFINIR SENHA" onClick={() => handleResetSenha()} className="btn btn-warning" />
            )
        } else {
            return (
                <></>
            )
        }
    }

    function handleCheckDashboard(check, index) {
        var objDashboard = Object.assign([], dashboards);

        var idusuario = null;
        if (selectedUsuario && selectedUsuario.id) {
            idusuario = selectedUsuario.id
        } else {
            idusuario = 999999999999;
        }

        if (!check) {
            objDashboard[index].user_relatorios = []
        } else {
            objDashboard[index].user_relatorios = [{
                dash_relatorios_id: objDashboard[index].id,
                usuario_id: idusuario,
            }]
        }

        setDashboards(objDashboard);
    }

    function renderDashboards() {
        return (
            dashboards.map((dashboard, index) => {
                if (dashboard.user_relatorios[0] && dashboard.user_relatorios[0].usuario_id) {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" checked onChange={() => handleCheckDashboard(0, index)} />{dashboard.descricao}</div>
                    )
                } else {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" onChange={() => handleCheckDashboard(1, index)} />{dashboard.descricao}</div>
                    )
                }
            })
        )
    }

    function handleCheckExportador(check, index) {
        var objExportador = Object.assign([], exportadores);

        var idusuario = null;
        if (selectedUsuario && selectedUsuario.id) {
            idusuario = selectedUsuario.id
        } else {
            idusuario = 999999999999;
        }

        if (!check) {
            objExportador[index].usuarios_exportador = []
        } else {
            objExportador[index].usuarios_exportador = [{
                exp_exportadores_id: objExportador[index].id,
                usuario_id: idusuario,
            }]
        }

        setExportadores(objExportador);
    }

    function renderExportadores() {
        return (
            exportadores.map((exportador, index) => {
                if (exportador.usuarios_exportador[0] && exportador.usuarios_exportador[0].usuario_id) {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" checked onChange={() => handleCheckExportador(0, index)} />{exportador.descricao}</div>
                    )
                } else {
                    return (
                        <div className={styles.divempresa}><input type="checkbox" onChange={() => handleCheckExportador(1, index)} />{exportador.descricao}</div>
                    )
                }
            })
        )
    }

    function handleSelectSetor(value) {
        const objsetores = Object.assign([], setores);
        objsetores.selectItem = value;
        setSetores(objsetores);
    }

    function handleOpenModalPessoa() {
        setModalPessoaOpen(true);
        setPessoas([]);
        setMatricula('');
        setNome('');
    }

    function renderModalUsuario() {
        return (
            <div className={(modalUsuarioOpen ? styles.modaldesp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => setModalUsuarioOpen(false)}>x</span>
                <div>
                    <h4>USUÁRIO</h4>
                </div>
                <div className={styles.bodyusuario}>
                    <div className={styles.columnusuario}>
                        <label>LOGIN</label>
                        <input type="text" value={usuario} onChange={(e) => setUsuario(e.target.value)}></input>
                    </div>
                    <div className={styles.columnusuario}>
                        <label>SETOR ADIANTAMENTO</label>
                        <select
                            className="combo-perfil form-control"
                            value={setores.selectItem} onChange={(e) => handleSelectSetor(parseInt(e.target.value))}
                        >
                            {setores.items.map((item, index) => (
                                <option key={index} value={item.id}>{item.text}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles.columnusuario}>
                        <label>MATRÍCULA</label>
                        <input type="text" value={(pessoa.matricula ? pessoa.matricula : '')} readOnly className={styles.matcol}></input>
                    </div>
                    <div className={styles.columnusuario}>
                        <label>BUSCAR</label>
                        <div className={styles.dadosfunc}>
                            <BsSearch size="25" className={styles.btnbuscafunc} onClick={() => handleOpenModalPessoa()} />
                            <label>{pessoa.nome}</label>
                        </div>
                    </div>
                    <div className={styles.btnredef}>
                        {renderBtnRedefinir()}
                    </div>
                </div>
                <hr />
                <div>
                    <div><b>EMPRESAS</b></div>
                    <div className={styles.divempresas}>
                        {renderEmpresas()}
                    </div>
                </div>
                <hr />
                <div>
                    <div><b>MÓDULOS</b></div>
                    <div className={styles.divmodulos}>
                        {rederModulos()}
                    </div>
                </div>
                <hr />
                <div>
                    <div><b>PERFIS</b></div>
                    <div className={styles.divempresas}>
                        {renderPerfis()}
                    </div>
                </div>
                {renderAreasOrcamento()}
                <hr />
                <div>
                    <div><b>EXPORTADORES</b></div>
                    <div className={styles.divexportadores}>
                        {renderExportadores()}
                    </div>
                </div>
                <hr />
                <div>
                    <div><b>DASHBOARDS</b></div>
                    <div className={styles.divdashboards}>
                        {renderDashboards()}
                    </div>
                </div>
                <input type="button" value="SALVAR" className='btn btn-success' onClick={() => handleClickSalvar()} />
            </div>
        )
    }

    function handleOpenModalUsuario(u) {
        if (u && u.id) {
            setUsuario(u.usuario);
            setSelectedUsuario(u);

            api.get(`/empresa/getbyuser?usuario_id=${u.id}`).then(function (response) {
                if (response.data) {
                    setEmpresas(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/modulos/getbyuser?usuario_id=${u.id}`).then(function (response) {
                if (response.data) {
                    setModulos(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/perfis/getbyuser?usuario_id=${u.id}`).then(function (response) {
                if (response.data) {
                    setPerfis(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/empresa/getareas?usuario_id=${u.id}`).then(function (response) {
                if (response.data) {
                    setEmpAreas(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/dashboards/getbyuser?usuario_id=${u.id}`).then(function (response) {
                if (response.data) {
                    setDashboards(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/exportadores/getbyuser?usuario_id=${u.id}`).then(function (response) {
                if (response.data) {
                    setExportadores(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

        } else {
            setUsuario('');
            setSelectedUsuario({});

            api.get(`/empresa/getbyuser?usuario_id=${null}`).then(function (response) {
                if (response.data) {
                    setEmpresas(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/modulos/getbyuser?usuario_id=${null}`).then(function (response) {
                if (response.data) {
                    setModulos(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/perfis/getbyuser?usuario_id=${null}`).then(function (response) {
                if (response.data) {
                    setPerfis(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/empresa/getareas?usuario_id=${null}`).then(function (response) {
                if (response.data) {
                    setEmpAreas(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/dashboards/getbyuser?usuario_id=${null}`).then(function (response) {
                if (response.data) {
                    setDashboards(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });

            api.get(`/exportadores/getbyuser?usuario_id=${null}`).then(function (response) {
                if (response.data) {
                    setExportadores(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }

        setModalUsuarioOpen(true);
    }

    function fecharModalPessoa() {
        setModalPessoaOpen(false);
    }

    function handleSelectEmpPessoa(value) {
        const objemppessoa = Object.assign([], empPessoas);
        objemppessoa.selectItem = value;
        setEmpPessoas(objemppessoa);
    }

    function handleBuscaPessoa() {

        api.get(`/pessoas/find?matricula=${matricula}&nome=${nome}&empresa_id=${empPessoas.selectItem}`).then(function (response) {
            if (response.data) {
                setPessoas(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function handleClickPessoa(pessoa) {
        setPessoa(pessoa);
        setModalPessoaOpen(false);
    }

    function renderPessoas() {
        return (
            pessoas.map((pessoa, index) => {
                return (
                    <tr onClick={() => handleClickPessoa(pessoa)} className={styles.rowpessoa} key={index}>
                        <td>{pessoa.matricula}</td>
                        <td>{pessoa.nome}</td>
                    </tr>
                )
            })
        )
    }

    function renderModalPessoa() {

        return (
            <div className={(modalPessoaOpen ? styles.modalpessoa : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalPessoa()}>x</span>
                <div>
                    <h4>PESSOAS</h4>
                </div>
                <div className={styles.dadospessoas}>
                    <div className={styles.coldadospessoa}>
                        <label>MATRÍCULA</label>
                        <input type="text" value={matricula} onChange={(e) => setMatricula(e.target.value)} />
                    </div>
                    <div className={styles.coldadospessoa}>
                        <label>NOME</label>
                        <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} />
                    </div>
                    <div className={styles.coldadospessoa}>
                        <label>EMPRESA</label>
                        <select
                            className="combo-perfil form-control"
                            value={empPessoas.selectItem} onChange={(e) => handleSelectEmpPessoa(e.target.value)}
                        >
                            {empPessoas.items.map((item, index) => (
                                <option key={index} value={item.id}>{item.text}</option>
                            ))}
                        </select>
                    </div>
                    <input type="button" value="BUSCAR" className='btn btn-sm btn-success' onClick={() => handleBuscaPessoa()} />
                </div>
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <td>MATRICULA</td>
                            <td>NOME</td>
                        </tr>
                    </thead>
                    <tbody>
                        {renderPessoas()}
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <>
            {renderModalPessoa()}
            {renderModalUsuario()}
            <div className="container-lg">
                <Header title="CADASTRO DE USUÁRIOS" />
                <BsFillPlusCircleFill
                    onClick={() => handleOpenModalUsuario()}
                    size="50"
                    color='green'
                    className={styles.newcategoria}
                />
                <br />
                <br />
                <table className='table table-sm'>
                    <thead>
                        <tr >
                            <th>USUARIO</th>
                            <th>SETOR ADIANTAMENTO</th>
                            <th>VÍNCULO COLABORADOR</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRow()}
                    </tbody>
                </table>
            </div>
        </>
    )
}